import io from 'socket.io-client';
import appConfig from '../config/app-config';

// Not defined. io([url][, options]) - url (String) (defaults to window.location)
const host = appConfig.socketUrl;

export default class socketAPI {

    connect() {
        this.socket = io(host, {query:"user_id=name=my_img_name"});
        this.socket.connect();

        return new Promise((resolve, reject) => {
            this.socket.on('connect', () => {
                console.log('Socket connected');
                console.log(this.socket.id);
                this.socket.emit('join');
                return resolve(this.socket);
            });
            this.socket.on('connect_error', error => {
                console.log('Socket error : ' + error.toString() );
                return reject(error);
            });
            // this.socket.on('update', (data) => {
            //     console.log('got update:',data);
            // });
        });
    }

    disconnect() {
        return new Promise(resolve => {
            this.socket.disconnect(() => {
                this.socket = null;
                resolve();
            });
        });
    }

    registerUser(user_id) {
        return this.emit('register_user', user_id);
    }

    unregisterUser() {
        return this.emit('unregister_user', null);
    }

    emit(event, data) {
        return new Promise((resolve, reject) => {
            if (!this.socket) return reject('No socket connection.');

            return this.socket.emit(event, data, response => {
                // Response is the optional callback that you can use with socket.io in every request. See 1 above.
                if (response.error) {
                    console.error(response.error);
                    return reject(response.error);
                }

                return resolve();
            });
        });
    }

    on(event, fun) {
        // No promise is needed here, but we're expecting one in the middleware.
        return new Promise((resolve, reject) => {
            if (!this.socket) return reject('No socket connection.');

            this.socket.on(event, fun);
            resolve();
        });
    }
}



// WEBPACK FOOTER //
// ./source/socket/socketClient.js